export default "__VITE_ASSET__B$EwXDAE__"